import { useAuth, useGet } from "@onefront/react-sdk";
import { useEffect } from "react";
import { buildHeaders } from "../../common-utils/buildHeaders";
import { useClientInformationStore } from "../../store/useClientInformationStore";

export function useGetDocumentById({
  id,
  workspaceId,
  reload,
  setReload,
  checkVisibility,
  setCheckVisibility,
}) {
  const authData = useAuth();
  const { selectedTenant: currentCompany } = useClientInformationStore();
  const clientId = currentCompany?.itemId;

  const { data, loading, hasLoaded, fetch, error } = useGet(
    `documentsApi://api/v1/documents/${id}?workspaceId=${workspaceId}&loggedItemId=${clientId}`,
    {
      headers: buildHeaders({ authData }),
    }
  );

  useEffect(() => {
    if (clientId) {
      fetch();
    }
    if (reload) {
      fetch();
      setReload(false);
    }
  }, [clientId, reload, id]);

  return { data, loading, hasLoaded, fetch, error };
}
